<div class="create-amenity-category">
    <form [formGroup]="amenityCategoryForm" (ngSubmit)="saveAmenityCategory()">
      <div class="form-group">
        <label for="name">Category Name</label>
        <input id="name" type="text" formControlName="name" pInputText />
        <div class="error" *ngIf="amenityCategoryForm.get('name')?.invalid && amenityCategoryForm.get('name')?.touched">
         <small class="text-danger">Category name is required.</small>
        </div>
      </div>
  
      <div class="form-group">
        <label for="description">Description</label>
        <textarea id="description" class="w-100" formControlName="description" rows="3" pInputTextarea></textarea>
        <div class="error" *ngIf="amenityCategoryForm.get('description')?.invalid && amenityCategoryForm.get('description')?.touched">
         <small class="text-danger">Description is required.</small>
        </div>
      </div>
      <div class="d-flex justify-content-end mt-2 p-1">
        <p-button type="submit" class="secondary-btn" [disabled]="amenityCategoryForm.invalid">Save</p-button>
      </div>
    </form>
 </div>